<template>
  <div class="top-left-container">
    <div class="top-left-container-inner">
      <div class="left-tabs">
        <ul class="sub-menu-tabs">
          <li
            v-for="(tab, tabIndex) in leftTabs"
            :key="tabIndex"
            :class="{
              active: selectedTab === tab.alias
            }"
            class="dropdown-item btn btn-block"
            style="padding: 0; font-size: 11px; font-weight: 500;"
            @click="setClickFromMenu(tab.alias)"
          >
            <span class="tabName"> {{ tab.alias }}</span>
            <span>
              <i class="fas fa-caret-right"></i>
            </span>
          </li>
        </ul>
      </div>
      <div class="morning-slots" style="margin: 0.3rem;">
        <div class="table-responsive">
          <table class="table table-bordered" style="margin-bottom: 0;">
            <thead>
              <tr>
                <td>Total</td>
                <th class="total-for-slot">{{selectedTab === 'noon' ?  sumNoon : selectedTab === 'morning' ?  sumMorning : selectedTab === 'evening' ? sumEvening : selectedTab === 'illness' ? sumIllness :  selectedTab === 'costum' ? sumCostum : selectedTab === 'any' ? sumAny : '--' }}</th>
                <th>{{ totalForDay !== null ? totalForDay[selectedTab][0].monday : '' }}</th>
                <th>{{ totalForDay !== null ? totalForDay[selectedTab][0].tuesday : '' }}</th>
                <th>{{ totalForDay !== null ? totalForDay[selectedTab][0].wednesday : '' }}</th>
                <th>{{ totalForDay !== null ? totalForDay[selectedTab][0].thursday : '' }}</th>
                <th>{{ totalForDay !== null ? totalForDay[selectedTab][0].friday  : ''}}</th>
                <th>x</th>
                <th>x</th>
              </tr>
              <tr>
                <td style="color: red; font-weight: 600">
                  {{ selectedTab }} shift
                </td>
                <th></th>
                <th v-for="day in days" :key="day.id">
                  {{ day.name }}
                  <span v-if="day.id < 7 && day.id !== 1" style="font-size: 9px">
                  {{tableHeadDates.length > 0 ? tableHeadDates[day.id -2] : getDateOfDay(day.id - 1)}}
                </span>
                </th>
              </tr>
            </thead>
            <tbody>
              <tr
                v-for="(shift, idx) in shifts"
                v-if="
                  shift.shifts[selectedTab].some(sh =>
                    sh.hasOwnProperty('choice_day_number')
                  )
                "
                :key="idx"
              >
                <th
                  v-if="shift.shifts[selectedTab].length > 0"
                  scope="row"
                  style="width: 160px;"
                >
                  {{ shift.shifts[selectedTab][0].user.full_name }}
                </th>
                <td>
                  {{ getTotalShiftsForUser(shift.shifts[selectedTab], 2) }}
                </td>
                <td style="position: relative">

                  <div
                    v-if="getShift(shift.shifts[selectedTab], 2) === 'V'"
                    class="shift-approved"
                    style="cursor: pointer"
                    @click="openApprovalDropdown(2, 2, idx)"
                  >
                    {{ getShift(shift.shifts[selectedTab], 2) }}
                    <span :class="checkShiftPriority(shift.shifts[selectedTab], 2)"></span>
                  </div>

                  <div
                    v-if="
                      getShift(shift.shifts[selectedTab], 2) === 'X'
                    "
                    class="shift-not-approved"
                    style="cursor: pointer"
                    @click="openApprovalDropdown(2, 2, idx)"
                  >
                    <div class="not-approved-dot" :class="checkShiftPriority(shift.shifts[selectedTab], 2)"></div>
                  </div>

                  <div v-if="getShift(shift.shifts[selectedTab], 2) === '---'"
                       style="cursor: pointer;"
                       @click="openApprovalDropdown(2, 2, idx, -2, {day: 2, user_id: shift.shifts[selectedTab][0].user.id})">
                    +
                  </div>
                  <span
                    v-if="
                      dropdown &&
                        dropdownNumber === 2 &&
                        dropdownShift === 2 &&
                        uniqueIdx === idx &&
                        overViewUserIndex === -2
                    "
                  >
                    <shifts-dropdown
                      :shift="getShiftForDropdown(shift.shifts[selectedTab], 2)"
                      :shift-status="
                        checkIfShiftIsApproved(shift.shifts[selectedTab], 2)
                      "
                      :no-shift-chosen="dropDownForNoShiftChosen"
                      @closeDropdown="dropdown = false"
                    ></shifts-dropdown>
                  </span>
                </td>

                <td style="position: relative">
                  <div
                    v-if="getShift(shift.shifts[selectedTab], 3) === 'V'"
                    class="shift-approved"
                    style="cursor: pointer"
                    @click="openApprovalDropdown(3, 2, idx)"
                  >
                    {{ getShift(shift.shifts[selectedTab], 3) }}
                  </div>

                  <div
                    v-if="getShift(shift.shifts[selectedTab], 3) === 'X'"
                    class="shift-not-approved"
                    style="cursor: pointer"
                    @click="openApprovalDropdown(3, 2, idx)"
                  >
                    <div class="not-approved-dot" :class="checkShiftPriority(shift.shifts[selectedTab], 3)"></div>
                  </div>

                  <div v-if="getShift(shift.shifts[selectedTab], 3) === '---'"
                       style="cursor: pointer"
                       @click="openApprovalDropdown(3, 2, idx, -2, {day: 3, user_id: shift.shifts[selectedTab][0].user.id})"
                  >
                    +
                  </div>
                  <span
                    v-if="
                      dropdown &&
                        dropdownNumber === 3 &&
                        dropdownShift === 2 &&
                        uniqueIdx === idx &&
                        overViewUserIndex === -2
                    "
                  >
                    <shifts-dropdown
                      :shift="getShiftForDropdown(shift.shifts[selectedTab], 3)"
                      :shift-status="
                        checkIfShiftIsApproved(shift.shifts[selectedTab], 3)
                      "
                      :no-shift-chosen="dropDownForNoShiftChosen"
                      @closeDropdown="dropdown = false"
                    ></shifts-dropdown>
                  </span>
                </td>
                <td style="position: relative">
                  <div
                    v-if="getShift(shift.shifts[selectedTab], 4) === 'V'"
                    class="shift-approved"
                    style="cursor: pointer"
                    @click="openApprovalDropdown(4, 2, idx)"
                  >
                    {{ getShift(shift.shifts[selectedTab], 4) }}
                  </div>

                  <div
                    v-if="getShift(shift.shifts[selectedTab], 4) === 'X'"
                    class="shift-not-approved"
                    style="cursor: pointer"
                    @click="openApprovalDropdown(4, 2, idx)"
                  >
                    <div class="not-approved-dot" :class="checkShiftPriority(shift.shifts[selectedTab], 4)"></div>
                  </div>

                  <div v-if="getShift(shift.shifts[selectedTab], 4) === '---'"
                       style="cursor: pointer"
                       @click="openApprovalDropdown(4, 2, idx, -2, {day: 4, user_id: shift.shifts[selectedTab][0].user.id})"
                  >
                    +
                  </div>
                  <span
                    v-if="
                      dropdown &&
                        dropdownNumber === 4 &&
                        dropdownShift === 2 &&
                        uniqueIdx === idx &&
                        overViewUserIndex === -2
                    "
                  >
                    <shifts-dropdown
                      :shift="getShiftForDropdown(shift.shifts[selectedTab], 4)"
                      :shift-status="
                        checkIfShiftIsApproved(shift.shifts[selectedTab], 4)
                      "
                      :no-shift-chosen="dropDownForNoShiftChosen"
                      @closeDropdown="dropdown = false"
                    ></shifts-dropdown>
                  </span>
                </td>
                <td style="position: relative">
                  <div
                    v-if="getShift(shift.shifts[selectedTab], 5) === 'V'"
                    class="shift-approved"
                    style="cursor: pointer"
                    @click="openApprovalDropdown(5, 2, idx)"
                  >
                    {{ getShift(shift.shifts[selectedTab], 5) }}
                  </div>
                  <div
                      v-if="getShift(shift.shifts[selectedTab], 5) === 'X'"
                      class="shift-not-approved"
                      style="cursor: pointer"
                      @click="openApprovalDropdown(5, 2, idx)"
                  >
                    <div class="not-approved-dot" :class="checkShiftPriority(shift.shifts[selectedTab], 5)"></div>
                  </div>
                  <div v-if="getShift(shift.shifts[selectedTab], 5) === '---'"
                       style="cursor: pointer"
                       @click="openApprovalDropdown(5, 2, idx, -2, {day: 5, user_id: shift.shifts[selectedTab][0].user.id})"
                  >
                    +
                  </div>
                  <span
                    v-if="
                      dropdown &&
                        dropdownNumber === 5 &&
                        dropdownShift === 2 &&
                        uniqueIdx === idx &&
                        overViewUserIndex === -2
                    "
                  >
                    <shifts-dropdown
                      :shift="getShiftForDropdown(shift.shifts[selectedTab], 5)"
                      :shift-status="
                        checkIfShiftIsApproved(shift.shifts[selectedTab], 5)
                      "
                      :no-shift-chosen="dropDownForNoShiftChosen"
                      @closeDropdown="dropdown = false"
                    ></shifts-dropdown>
                  </span>
                </td>
                <td style="position: relative">
                  <div
                    v-if="getShift(shift.shifts[selectedTab], 6) === 'V'"
                    class="shift-approved"
                    style="cursor: pointer"
                    @click="openApprovalDropdown(6, 2, idx)"
                  >
                    {{ getShift(shift.shifts[selectedTab], 6) }}
                  </div>
                  <div
                      v-if="getShift(shift.shifts[selectedTab], 6) === 'X'"
                      class="shift-not-approved"
                      style="cursor: pointer"
                      @click="openApprovalDropdown(6, 2, idx)"
                  >
                    <div class="not-approved-dot" :class="checkShiftPriority(shift.shifts[selectedTab], 6)" :title="'not approved'"></div>
                  </div>


                  <div v-if="getShift(shift.shifts[selectedTab], 6)=== '---'"
                       style="cursor: pointer"
                       @click="openApprovalDropdown(6, 2, idx, -2, {day: 6, user_id: shift.shifts[selectedTab][0].user.id})"
                       >
                    +
                  </div>
                  <span
                    v-if="
                      dropdown &&
                        dropdownNumber === 6 &&
                        dropdownShift === 2 &&
                        uniqueIdx === idx &&
                        overViewUserIndex === -2
                    "
                  >
                    <shifts-dropdown
                      :is-friday="true"
                      :shift="getShiftForDropdown(shift.shifts[selectedTab], 6)"
                      :shift-status="
                        checkIfShiftIsApproved(shift.shifts[selectedTab], 6)
                      "
                      @closeDropdown="dropdown = false"
                      :no-shift-chosen="dropDownForNoShiftChosen"
                    ></shifts-dropdown>
                  </span>
                </td>
                <td>
                  x
                </td>
                <td>
                  x
                </td>
                <td style="position: relative">
                  <i class="fas fa-user-edit" @click="openApprovalDropdown(8, 2, idx, -2, null, true)"></i>
                  <span
                      v-if="
                      dropdown &&
                        dropdownNumber === 8 &&
                        dropdownShift === 2 &&
                        uniqueIdx === idx &&
                        overViewUserIndex === -2 &&
                        showEditUserShiftsPopUp
                    "
                  >
                    <shifts-dropdown
                        :edit="true"
                        :user="shift.shifts[selectedTab][0].user"
                        @closeDropdown="dropdown = false"
                    ></shifts-dropdown>
                  </span>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import apiClientCreator from "@/helpers/api/request";
import ShiftsDropdown from "./ShiftsDropdown";
import moment from "moment";

export default {
  name: "ShiftsTopLeftContainer",
  props: {
    fetchNew: {
      type: Boolean,
      default: false
    },
    filterDates: {
      type: Object
    }
  },
  components: {
    ShiftsDropdown
  },
  mounted() {
    this.fetchShiftList();
    this.getTotalShiftsForDay()
    this.fetchTotalSumForSlots()
  },

  data() {
    return {
      tableHeadDates: [],
      days: [
        {
          id: 2,
          name: "Mon"
        },
        {
          id: 3,
          name: "Tue"
        },
        {
          id: 4,
          name: "Wed"
        },
        {
          id: 5,
          name: "Thu"
        },
        {
          id: 6,
          name: "Fri"
        },
        {
          id: 7,
          name: "Sat"
        },
        {
          id: 1,
          name: "Sun"
        },
        {
          id: 8,
          name: "Edit"
        },
      ],
      leftTabs: [
        {
          id: 1,
          name: "Morning",
          alias: "morning"
        },
        {
          id: 2,
          name: "Noon",
          alias: "noon"
        },
        {
          id: 3,
          name: "Evening",
          alias: "evening"
        },
        {
          id: 4,
          name: "Illness",
          alias: "illness"
        },
        {
          id: 5,
          name: "Costum",
          alias: "costum"
        },
        {
          id: 6,
          name: "Any",
          alias: "any"
        },
      ],
      selectedTab: "morning",
      dropdown: false,
      dropdownNumber: 0,
      uniqueIdx: null,
      overViewUserIndex: null,
      showEditUserShiftsPopUp: false,
      dropDownForNoShiftChosen: {
        day: null,
        user_id: null
      },
      dropdownShift: 0,
      shifts: [],
      // shiftsByUser: [],
      userModelShifts: [],
      allShiftsApproved: false,
      sumMorning: null,
      sumNoon: null,
      sumEvening: null,
      sumIllness: null,
      sumCostum: null,
      sumAny: null,
      totalForDay: null
    };
  },
  methods: {
    getDateOfDay(amount = 1){
      return moment().endOf('week').add(amount + 1, 'days').format("DD/MMM")
    },
    async fetchShiftList(dates = null) {
      let getShiftList = apiClientCreator("shifts/list");
      if(dates !== null){
        let d = {
          shifts_from: moment(dates.start).format('Y-MM-DD'),
          shifts_to: moment(dates.end).format('Y-MM-DD')
        }
        let result = await getShiftList.get("", {params: d});
        this.shifts = result.data;
      }else{
        let result = await getShiftList.get("");
        this.shifts = result.data;
      }
      //this.$emit('fetched')
    },
    approveUser(id, unApprove = false) {
      if (unApprove === false) {
        let approveUser = apiClientCreator(
          `shifts/approve_all_shifts_for_single_user/${id}`
        );
        approveUser.post("", {}).then(res => {
          this.fetchShiftList();
        });
      }
      if (unApprove === true) {
        let approveUser = apiClientCreator(
          `shifts/approve_all_shifts_for_single_user/${id}`
        );
        approveUser
          .post("", {
            unApprove: unApprove
          })
          .then(res => {
            // this.fetchShiftsByUser();
            this.fetchShiftList();
          });
      }
    },
    setClickFromMenu(tab) {
      this.selectedTab = tab;
    },
     getTotalShiftsForDay(){
       apiClientCreator("shifts/get_total_shifts_for_day")
            .get("").then(res => {
              this.totalForDay = res.data
            });

    },
    async fetchTotalSumForSlots() {
      let sumShiftsForSlots = apiClientCreator("shifts/sum_shifts_for_slots");
      let result = await sumShiftsForSlots.get("");
      this.sumMorning = result.data.morning;
      this.sumNoon = result.data.noon;
      this.sumEvening = result.data.evening;
      this.sumIllness = result.data.illness;
      this.sumCostum = result.data.costum;
      this.sumAny = result.data.any;
    },
    fetchThisWeekShifts(type) {
      let m = [];
      let n = [];
      let e = [];
      let thisWeekShifts = apiClientCreator(
        `shifts/shifts_for_this_week/${type}`
      );
      thisWeekShifts.get("").then(({ data }) => {
        if (data.length > 0) {
          data.forEach(s => {
            if (type === 1) {
              m.push(s.user.full_name);
            }
            if (type === 2) {
              n.push(s.user.full_name);
            }
            if (type === 3) {
              e.push(s.user.full_name);
            }
          });
          if (type === 1) {
            this.morning = m;
          }
          if (type === 2) {
            this.noon = n;
          }
          if (type === 3) {
            this.evening = e;
          }
        } else {
        }
      });
    },
    openApprovalDropdown(day, shift, idx = -1, extraIdx = -2, noShiftChosen = null, edit = false) {
      this.overViewUserIndex = extraIdx;
      this.uniqueIdx = idx;
      this.dropdownNumber = day;
      this.dropdownShift = shift;
      this.dropdown = !this.dropdown;
      this.dropDownForNoShiftChosen = noShiftChosen
      if(edit === true){
        this.showEditUserShiftsPopUp = true
      }
    },
    getShift(shift, day) {
      if (shift.some(s => s.choice_day_number === day)) {
        if (shift.some(s => s.choice_day_number === day)) {
          let type = "shift-not-approved";
          shift.some(s => {
            if (s.choice_day_number === day && s.approved === 1) {
              type = "shift-approved";
            }
          });
          if (type === "shift-approved") {
            return "V";
          }
          if (type === "shift-not-approved") {
            return "X";
          }
        }
      } else {
        return "---";
      }
    },

    checkShiftPriority(shift, day) {
        if (shift.some(s => s.choice_day_number === day)) {
          let type = "";
          shift.some(s => {
            if (s.priority === 1 && s.approved === 1) {
              type = "shift-approved-is-priority-dot";
            }
            if(s.priority === 1 && s.approved === 0){
              type = "not-approved-priority-dot"
            }
          });
          if (type === "shift-approved-is-priority-dot") {
            return type;
          }
          if (type === "not-approved-priority-dot") {
            return type;
          }
        }
       else {
        return '';
      }
    },
    getShiftForDropdown(shift, day) {
      let r;
      if (shift.some(s => s.choice_day_number === day)) {
        shift.forEach(item => {
          if (item.choice_day_number === day) {
            r = item;
          }
        });
        return r;
      } else {
        return "---";
      }
    },
    getTotalShiftsForUser(slot, shiftNumber) {
      let sum = slot.map(s => s.hasOwnProperty("approved"));
      return sum.filter(Boolean).length;
    },
    async approveAllShifts() {
      let getShiftList = apiClientCreator("shifts/approve_all_shifts");
      let result = await getShiftList.get("");
      if (result.data[0] === true) {
        this.allShiftsApproved = true;
        await this.fetchShiftList();
      }
      if (result.data[0] === false) {
        this.allShiftsApproved = false;
      }
    },
    checkIfShiftIsApproved(shift, day) {
      if (shift.some(s => s.choice_day_number === day)) {
        let type = "shift-not-approved";
        shift.some(s => {
          if (s.choice_day_number === day && s.approved === 1) {
            type = "shift-approved";
          }
        });
        if (type === "shift-approved") {
          return type;
        }
      }
    },
    checkWhoApproved(shift, day) {
      let a = { full_name: "Not approved" };
      if (shift.some(s => s.choice_day_number === day)) {
        shift.some(s => {
          if (s.approved === 1) {
            a = s.approved_by;
          }
        });
        return a;
      }
      return a;
    }
  },
  watch: {
    filterDates: function(){
      if(this.filterDates.hasOwnProperty('date')){
        //this.fetchShiftList(this.filterDates.date);
        let start = moment(this.filterDates.date.start).startOf('isoWeek').format('Y-MM-DD');
        let additions = [0, 1, 2, 3, 4];
        let dates = additions.map(d => moment(start).add(d, 'days').format("DD/MMM"))
        this.tableHeadDates = dates
      }
    },

    fetchNew: function() {
      if (this.fetchNew) {
        if(this.filterDates.hasOwnProperty('date')){
          this.fetchShiftList(this.filterDates.date);
          let start = moment(this.filterDates.date.start).startOf('isoWeek').format('Y-MM-DD');
          let additions = [0, 1, 2, 3, 4];
          let dates = additions.map(d => moment(start).add(d, 'days').format("DD/MMM"))
          this.tableHeadDates = dates
          //this.selectedTab = 'any';
        }else{
          this.fetchShiftList();
        }
        this.getTotalShiftsForDay()
      }
    },
    dropdown: function() {
      if (this.dropdown === false) {
        this.dropdownNumber = 0;
        this.dropdownShift = 0;
        this.uniqueIdx = null;
        this.overViewUserIndex = null;
        if(this.filterDates.hasOwnProperty('date')){
          this.fetchShiftList(this.filterDates.date);
        }else{
          this.fetchShiftList();
        }
        this.fetchTotalSumForSlots();
        this.getTotalShiftsForDay()
      }
    },
    selectedTab: function(){}
  }
};
</script>

<style scoped>
.morning-slots {
  padding: 1px;
  margin-top: 2rem;
  width: 100%;
  height: 230px;
  border: 1px solid black;
  overflow-y: scroll;
}
.morning-slots::-webkit-scrollbar {
  width: 9px;
  height: 9px;
}
.morning-slots::-webkit-scrollbar-thumb {
  background: linear-gradient(13deg, #C7CEFF 14%,#c7ceff 64%);
  border-radius: 10px;
}
.morning-slots::-webkit-scrollbar-track{
  background: #ffffff;
  border-radius: 10px;
  box-shadow: inset 7px 10px 12px #f0f0f0;
}

.top-left-container {
  float: left;
  width: calc(45%);
  background: white;
}

.top-left-container-inner {
  min-height: 100%;
  position: relative;
  font-family: Montserrat;
  padding-top: 12px;
  padding-right: 12px;
  display: flex;
  width: 100%;
}

.sub-menu-tabs {
  left: -9px;
  bottom: 22px;
  min-width: 115px;
  border-radius: 0;
  padding: 0;
  max-height: 160px;
  min-height: 160px;
  text-transform: uppercase;
}

li.active {
  background-color: #c12fff;
  color: #fff;
}

span.tabName {
  padding-right: 10px;
}

.table-responsive {
  width: 100%;
  overflow: visible;
}

.shift-approved {
  color: #0bd425 !important;
}

.shift-not-approved {
  cursor: pointer;
  display: flex;
  justify-content: center;
  align-items: center;
}

th,
td {
  font-size: 11px;
  text-align: center;
}

th {
  font-weight: 600;
}
.not-approved-dot{
  height: 12px;
  width: 12px;
  background-color: orange;
  border-radius: 50%;
}
.not-approved-priority-dot{
  height: 12px;
  width: 12px;
  background-color: #dd0505;
  border-radius: 50%;
}

.shift-approved-is-priority-dot{
  height: 12px;
  width: 12px;
  background-color: #04b81c !important;
  border-radius: 50%;
}

</style>
